import classNames from 'classnames';
import React, { ReactElement, useMemo } from 'react';

import { IParentProps } from '../../../shared/types/IParentProps';
import { IQATestableProps } from '../../../shared/types/IQATestableProps';
import { IStyleableProps } from '../../../shared/types/IStyleableProps';
import { IGridVisibilityProps } from '../shared/IGridVisibilityProps';
import { useVisibilityClassNames } from '../shared/useVisibilityClassNames';

export type IGridRowProps = IGridVisibilityProps & IParentProps & IQATestableProps & IStyleableProps;

export function OzGridRow (props: IGridRowProps): ReactElement {
    const {
        className = '',
        'data-testid': dataTestId,
        children,
    }: IGridRowProps = props;

    const visibilityClassNames: string = useVisibilityClassNames(props);

    const rowClassNames: string = useMemo((): string => {
        return classNames([
            className,
            'w-full p-0 flex flex-wrap',
            visibilityClassNames,
        ]);
    }, [
        className,
        visibilityClassNames,
    ]);

    return (
        <div className={rowClassNames} data-testid={dataTestId}>{children}</div>
    );
}
